import React from "react";

export const QnAWriteChevronIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="#222222"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QnAWritePlusIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden>
    <path
      d="M20 8.33334V31.6667M8.33334 20H31.6667"
      stroke="#767676"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QnAWriteCloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path
      d="M12 4L4 12M4 4L12 12"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
